import type { MessageTree } from "./th-TH"

export const enUS: MessageTree = {
  nav: {
    menu: "Menu",
    solutions: "Solutions",
    guides: "Guides",
    shop: "Shop",
    used: "Used",
    ecosystem: "Ecosystem software",
    account: "Account",
    cart: "Cart",
    home: "Home",
    contact: "Contact",
    language: "Language",
    searchOpen: "Open search",
    searchClose: "Close search",
  },
  chat: {
    askProducts: "Ask products",
    team: "Talk to team",
    line: "LINE",
    modeAssistant: "Ask products",
    modeTeam: "Talk to team",
    modeLine: "LINE",
    subtitleAssistant: "Find products and answer catalog questions",
    subtitleTeam: "Message the VX Work team",
    subtitleLine: "Chat with VX Work on LINE Official Account",
    greeting: "Hi — what can I help you find in the catalog today?",
    greetingHint:
      "Ask about models, specs, or budget — I search real in-store products.",
    teamHint: "Ask about products, services, or a quote anytime",
    placeholderAssistant: "Type a question or pick a topic above…",
    placeholderTeam: "Message the team, e.g. Is CRS328 in stock?",
    lineTitle: "LINE Official Account",
    lineBody: "Chat with the VX Work team on LINE",
    lineCta: "Start LINE chat now",
    lineHint: "To chat in the LINE app directly, tap below",
    close: "Close chat",
    clear: "Clear chat",
    unavailable: "Assistant is unavailable. Please try again later.",
    connectFailed: "Could not reach the assistant. Please try again.",
    errorGeneric: "Something went wrong contacting the assistant. Please retry.",
  },
  home: {
    metaTitle: "VX Work — Network solutions & software",
    metaDescription:
      "Knowledge hub and network solutions for hotels and offices, plus hardware shop and ecosystem software like KEOS",
    solutionsCta: "View solutions →",
    shopCta: "Open shop",
    whatsNewTitle: "New in the shop",
    whatsNewBody: "Notable models from the catalog — check specs and ask the team",
    whatsNewCta: "Open shop →",
  },
  footer: {
    blurb: "Network solutions and software hub for hotels, offices, and SMEs —",
    solutions: "Solutions",
    shop: "Shop",
  },
}
